// extracted by mini-css-extract-plugin
export var equalColumn = "_gu-0";